module.exports = __webpack_public_path__ + "img/quan-item-2.7fc384a1.png";